import { render, staticRenderFns } from "./StatusInfo.vue?vue&type=template&id=f0f8c7cc"
import script from "./StatusInfo.ts?vue&type=script&lang=ts&external"
export * from "./StatusInfo.ts?vue&type=script&lang=ts&external"
import style0 from "./StatusInfo.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports